// Module
var code = " <gb-button ng-click=\"$ctrl.addWidget()\" icon=\"add\"> <span translate=\"ADD_ITEM_TABLE_WIDGET_BUTTON\"></span> </gb-button> <gb-edit-item-table-widget widget=\"$ctrl.getWidget()\"></gb-edit-item-table-widget> ";
// Exports
export default code;